import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    // i18next-browser-languagedetector s'occupe du localStorage tout seul !
    i18n.changeLanguage(language);
  };

  // On extrait la racine de la langue (ex: "en-US" devient "en")
  const currentLang = i18n.language ? i18n.language.split('-')[0] : 'fr';

  return (
    <div className="language-switcher" role="navigation" aria-label="Language selector">
      <button
        type="button"
        className={`lang-text ${currentLang === "fr" ? "selected" : ""}`}
        onClick={() => handleLanguageChange("fr")}
        aria-pressed={currentLang === "fr"}
      >
        FR
      </button>

      <span className="separator" aria-hidden="true">|</span>

      <button
        type="button"
        className={`lang-text ${currentLang === "en" ? "selected" : ""}`}
        onClick={() => handleLanguageChange("en")}
        aria-pressed={currentLang === "en"}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;